var overArg = require('./_overArg');

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;



//////////////////
// WEBPACK FOOTER
// ./~/_lodash@4.17.11@lodash/_getPrototype.js
// module id = 190
// module chunks = 0